import type { JSX } from 'react'

export const TvSolidIcon = (): JSX.Element => (
  <use href='#tvSolidIcon' height='100%' width='100%' />
)
